import 'es6-object-assign/auto'
import Vue from 'vue'
import CreateAccount from './CreateAccount.vue';
import '../../common/GlobalVueConfig';


new Vue({
    render: h => h(CreateAccount)
}).$mount('#create-account-app');
